export type Lang = 'de' | 'en' | 'tr' | 'ar';

export interface Dict {
  welcome: string;
  tenantName: string;
  tenantLoc: string;
  idleTitle: string;
  contentHeadline: string;
  contentSub: string;
  contentDate: string;
  startCall: string;
  callingTitle: string;
  callingSub: string;
  cancel: string;
  liveWith: string;
  selfView: string;
  waitingTitle: string;
  waitLabel: string;
  waitPos: string;
  bookApp: string;
  unavailTitle: string;
  unavailDesc: string;
  noAgentTitle: string;
  noAgentDesc: string;
  serviceHours: string;
  consentTitle: string;
  consentText: string;
  decline: string;
  accept: string;
  consentCancelled: string;
  feedbackTitle: string;
  feedbackSub: string;
  submit: string;
  goodbyeTitle: string;
  goodbyeSub: string;
  langTitle: string;
  langSub: string;
}

export const i18n: Record<Lang, Dict> = {
  de: {
    noAgentTitle: 'Aktuell kein Berater verfügbar',
    noAgentDesc: 'Aktuell ist kein Berater verfügbar. Bitte versuchen Sie es später erneut.',
    welcome: 'Willkommen',
    tenantName: '',
    tenantLoc: '',
    idleTitle: 'Persönliche Beratung – <strong>jetzt verfügbar</strong>',
    contentHeadline: 'Persönlich. <strong>Vor Ort.</strong>',
    contentSub: 'Sprechen Sie mit unseren Beratern – heute zwischen 8 und 18 Uhr.',
    contentDate: 'Donnerstag · 21. Mai',
    startCall: 'Beratung starten',
    callingTitle: 'Wir verbinden Sie',
    callingSub: 'Einen kleinen Moment, bitte',
    cancel: 'Abbrechen',
    liveWith: 'Ihr Berater',
    selfView: 'Du',
    waitingTitle: 'Alle Berater im Gespräch',
    waitLabel: 'Geschätzte Wartezeit',
    waitPos: 'Position 2 in der Warteschlange',
    bookApp: 'Termin vereinbaren',
    unavailTitle: 'Außerhalb der Servicezeiten',
    unavailDesc: 'Unsere Beraterinnen und Berater sind aktuell nicht erreichbar.',
    serviceHours: 'Mo – Fr · 08:00 – 18:00',
    consentTitle: 'Aufzeichnung der Beratung',
    consentText:
      'Ihre Beraterin möchte dieses Gespräch zur Qualitätssicherung aufzeichnen. Die Aufzeichnung wird verschlüsselt für 90 Tage gespeichert.',
    decline: 'Ablehnen',
    accept: 'Zustimmen',
    consentCancelled: 'Der Berater hat die Anfrage abgebrochen.',
    feedbackTitle: 'Wie war Ihr Gespräch?',
    feedbackSub: 'Eine kurze Rückmeldung hilft uns',
    submit: 'Absenden',
    goodbyeTitle: 'Vielen Dank',
    goodbyeSub: 'für Ihren Besuch',
    langTitle: 'Bitte wählen Sie Ihre Sprache',
    langSub: 'Please select your language',
  },
  en: {
    noAgentTitle: 'No advisor available right now',
    noAgentDesc: 'No advisor is available at the moment. Please try again later.',
    welcome: 'Welcome',
    tenantName: '',
    tenantLoc: '',
    idleTitle: 'Personal advisory – <strong>available now</strong>',
    contentHeadline: 'Personal. <strong>On-site.</strong>',
    contentSub: 'Speak with our advisors – today from 8am to 6pm.',
    contentDate: 'Thursday · May 21',
    startCall: 'Start advisory',
    callingTitle: 'Connecting you',
    callingSub: 'Just a moment, please',
    cancel: 'Cancel',
    liveWith: 'Your advisor',
    selfView: 'You',
    waitingTitle: 'All advisors in conversation',
    waitLabel: 'Estimated wait',
    waitPos: 'Position 2 in queue',
    bookApp: 'Book appointment',
    unavailTitle: 'Outside service hours',
    unavailDesc: 'Our advisors are currently unavailable.',
    serviceHours: 'Mon – Fri · 08:00 – 18:00',
    consentTitle: 'Recording of the conversation',
    consentText:
      'Your advisor would like to record this conversation for quality assurance. The recording will be encrypted and stored for 90 days.',
    decline: 'Decline',
    accept: 'Accept',
    consentCancelled: 'The advisor cancelled the request.',
    feedbackTitle: 'How was your conversation?',
    feedbackSub: 'A short feedback helps us',
    submit: 'Submit',
    goodbyeTitle: 'Thank you',
    goodbyeSub: 'for your visit',
    langTitle: 'Please select your language',
    langSub: 'Bitte wählen Sie Ihre Sprache',
  },
  tr: {
    noAgentTitle: 'Şu anda danışman yok',
    noAgentDesc: 'Şu anda müsait bir danışman yok. Lütfen daha sonra tekrar deneyin.',
    welcome: 'Hoş geldiniz',
    tenantName: '',
    tenantLoc: '',
    idleTitle: 'Kişisel danışmanlık – <strong>şimdi müsait</strong>',
    contentHeadline: 'Kişisel. <strong>Yerinde.</strong>',
    contentSub: 'Danışmanlarımızla konuşun – bugün 8 ile 18 arası.',
    contentDate: 'Perşembe · 21 Mayıs',
    startCall: 'Danışmanlığı başlat',
    callingTitle: 'Sizi bağlıyoruz',
    callingSub: 'Bir dakikanızı alalım',
    cancel: 'İptal',
    liveWith: 'Danışmanınız',
    selfView: 'Sen',
    waitingTitle: 'Tüm danışmanlar görüşmede',
    waitLabel: 'Tahmini bekleme süresi',
    waitPos: 'Sırada 2. konumdasınız',
    bookApp: 'Randevu al',
    unavailTitle: 'Hizmet saatleri dışında',
    unavailDesc: 'Danışmanlarımız şu anda müsait değil.',
    serviceHours: 'Pzt – Cum · 08:00 – 18:00',
    consentTitle: 'Görüşme Kaydı',
    consentText:
      'Danışmanınız bu görüşmeyi kalite güvencesi için kaydetmek istiyor. Kayıt şifrelenecek ve 90 gün boyunca saklanacaktır.',
    decline: 'Reddet',
    accept: 'Kabul Et',
    consentCancelled: 'Danışman talebi iptal etti.',
    feedbackTitle: 'Görüşmeniz nasıldı?',
    feedbackSub: 'Kısa bir geri bildirim bize yardımcı olur',
    submit: 'Gönder',
    goodbyeTitle: 'Teşekkür ederiz',
    goodbyeSub: 'ziyaretiniz için',
    langTitle: 'Lütfen dilinizi seçin',
    langSub: 'Please select your language',
  },
  ar: {
    noAgentTitle: 'لا يوجد مستشار متاح حالياً',
    noAgentDesc: 'لا يوجد مستشار متاح في الوقت الحالي. يرجى المحاولة لاحقاً.',
    welcome: 'أهلاً وسهلاً',
    tenantName: '',
    tenantLoc: '',
    idleTitle: 'استشارة شخصية – <strong>متاحة الآن</strong>',
    contentHeadline: 'شخصية. <strong>في الفرع.</strong>',
    contentSub: 'تحدث مع مستشارينا – اليوم من 8 إلى 18.',
    contentDate: 'الخميس · ٢١ مايو',
    startCall: 'ابدأ الاستشارة',
    callingTitle: 'نقوم بتوصيلك',
    callingSub: 'لحظة واحدة من فضلك',
    cancel: 'إلغاء',
    liveWith: 'مستشارك',
    selfView: 'أنت',
    waitingTitle: 'جميع المستشارين مشغولون',
    waitLabel: 'وقت الانتظار المتوقع',
    waitPos: 'المركز ٢ في قائمة الانتظار',
    bookApp: 'حجز موعد',
    unavailTitle: 'خارج ساعات الخدمة',
    unavailDesc: 'مستشارونا غير متاحين حالياً.',
    serviceHours: 'الاثنين – الجمعة · 08:00 – 18:00',
    consentTitle: 'تسجيل الاستشارة',
    consentText:
      'تود مستشارتك تسجيل هذه المحادثة لضمان الجودة. سيتم تشفير التسجيل وتخزينه لمدة 90 يوماً.',
    decline: 'رفض',
    accept: 'موافقة',
    consentCancelled: 'ألغى المستشار الطلب.',
    feedbackTitle: 'كيف كانت محادثتك؟',
    feedbackSub: 'ملاحظات قصيرة تساعدنا',
    submit: 'إرسال',
    goodbyeTitle: 'شكراً جزيلاً',
    goodbyeSub: 'لزيارتك',
    langTitle: 'الرجاء اختيار لغتك',
    langSub: 'Please select your language',
  },
};
